/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Eventreport_Pain_Item21Inputs */

const ja_playdata_eventreport_pain_item21 = /** @type {(inputs: Playdata_Eventreport_Pain_Item21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`競合の大会の視聴者数を把握してベンチマークを設定したい`)
};

const en_playdata_eventreport_pain_item21 = /** @type {(inputs: Playdata_Eventreport_Pain_Item21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I want to benchmark against competing events' viewer numbers`)
};

/**
* | output |
* | --- |
* | "I want to benchmark against competing events' viewer numbers" |
*
* @param {Playdata_Eventreport_Pain_Item21Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_eventreport_pain_item21 = /** @type {((inputs?: Playdata_Eventreport_Pain_Item21Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Eventreport_Pain_Item21Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_eventreport_pain_item21(inputs)
	return en_playdata_eventreport_pain_item21(inputs)
});
export { playdata_eventreport_pain_item21 as "playdata_eventReport_pain_item2" }